import { combineReducers } from "redux"; 
import todolist from "./todolist"; 
export default combineReducers({ 
    todolist
});